// A link to a destination of the mock case: a comparison, a contract file or the Kostenwächter. The router's
// own link carries the typed route and its parameters; the design system's classes style the anchor.

import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import type { CaseTarget } from "../../lib/mock";

interface CaseLinkProps {
  target: CaseTarget;
  className?: string;
  children: ReactNode;
}

export function CaseLink({ target, className, children }: CaseLinkProps) {
  if (target.kind === "vergleich") {
    return (
      <Link to="/vergleiche/$vergleichId" params={{ vergleichId: target.vergleichId }} className={className}>
        {children}
      </Link>
    );
  }
  if (target.kind === "vertrag") {
    return (
      <Link to="/vertraege/$vertragId" params={{ vertragId: target.vertragId }} className={className}>
        {children}
      </Link>
    );
  }
  return (
    <Link to="/kosten" className={className}>
      {children}
    </Link>
  );
}
